// extracted by mini-css-extract-plugin
export default {"layout":"ProductImportPage_layout__mdThy","tableBox":"ProductImportPage_tableBox__RtjEK"};